import { EventEmitter, Inject } from "@angular/core";
import { Component } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialog {
  public confirmDialogEvent = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialog>, 
    @Inject(MAT_DIALOG_DATA) public data: IConfirmDialogData) {}

  public getTitle(): string {
    return this.data.title;
  }

  public getText(): string {
    return this.data.text;
  }

  public getBtnBack(): string {
    if(!this.data.btnBack){
      return "CANCELAR";
    }
    return this.data.btnBack;
  }

  public getBtnOk(): string {
    if(!this.data.btnOk){
      return "CONFIRMAR";
    }
    return this.data.btnOk;
  }

  public closeDialog(isClosedAction:boolean): void {
    this.dialogRef.close(isClosedAction);
  }

  public emitConfirmEvent() {
    this.confirmDialogEvent.emit();
    this.closeDialog(true);
  }
}

export interface IConfirmDialogData {
  title: string;
  text: string;
  btnOk: string;
  btnBack: string;
}
